module.exports = __webpack_public_path__ + "static/play-fc8eb2370715f0248b20d902cba23fc0.png";